// extracted by mini-css-extract-plugin
export default {"labelContainer":"_2p9nxaxlxnaGGlg8DPVNdD","iconContainer":"_13qOALydmkd_AdwXm-mtMD"};